// Extends From
import AuthSerializer from './base';
// Ember Imports
import { isEmpty } from '@ember/utils';
// Internal Imports
import QrStatus from '@linc-technologies/linced-common/enums/qr-status';

// QrCodeSerializer normalizes incoming qrcode responses from the auth server,
// so we can be afforded the batteries ember provides around store operations
// and record relational linking.
export default class QrCode extends AuthSerializer {
  /**
   * normalize is used to convert a single JSON record received from your
   * external data source into the normalized form store.push() expects.
   *
   * @param {Model} modelClass - modelClass provides an instance of the underlying model the payload is being normalized to.
   * @param {Object} resourceHash - resourceHash provides a single raw JSON document to be normalized into the specified JSON-API model class.
   * @returns {Object} - A JSON-API compliant document.
   */
  normalize(modelClass, resourceHash) {
    // key the record by the connected person.
    if (resourceHash.personId) {
      resourceHash.id = resourceHash.personId;
    }

    // data is a reserved key in ember-data land, move incoming data to qrData.
    if (resourceHash.data) {
      resourceHash.qrData = resourceHash.data;
      delete resourceHash.data;
    }

    // If we don't receive an error from the backend, ensure we mark it as such,
    // as null is illegal.
    if (isEmpty(resourceHash.status)) {
      resourceHash.status = QrStatus.ERROR;
    }

    return super.normalize(...arguments);
  }

  // note:
  // - we don't need to serialize qr code records as only the server creates
  //   records.
}
